var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClusterZoomIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9 6c-.414 0-.75.336-.75.75v1.5h-1.5c-.414 0-.75.336-.75.75s.336.75.75.75h1.5v1.5c0 .414.336.75.75.75s.75-.336.75-.75v-1.5h1.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-1.5v-1.5C9.75 6.336 9.414 6 9 6z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.187 14.618c-1.165.859-2.607 1.367-4.169 1.367C5.142 15.985 2 12.855 2 8.992 2 5.131 5.142 2 9.018 2s7.018 3.13 7.018 6.992c0 1.586-.53 3.049-1.422 4.222l3.093 3.081c.391.39.39 1.023 0 1.412-.392.39-1.027.39-1.418 0l-3.102-3.09zm.844-5.626c0 2.759-2.244 4.995-5.013 4.995-2.768 0-5.013-2.236-5.013-4.995 0-2.758 2.245-4.994 5.013-4.994 2.769 0 5.013 2.236 5.013 4.994z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClusterZoomIn);
export default __webpack_public_path__ + "static/media/cluster-zoom-in.43f66a51d025e9d76a8331514961174a.svg";
export { ForwardRef as ReactComponent };